import React, { useEffect, useState } from "react";
import { addExpense, getExpensesByPg } from "./apiService";
import { useAuth } from "./auth";
import { useNavigate } from "react-router-dom";

const AddExpense = () => {
  const [expname, setExpname] = useState("");
  const [expamt, setExpamt] = useState("");
  // const [explist, setExplist] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [errors, setErrors] = useState({});
  const { pgid } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getExpensesByPg(pgid).then((res) => {
      setExpenses(res);
    });
  }, [pgid]);

  const handleExpenseSubmit = () => {
    let errors = {};
    if (!expname) errors.expname = "Expense name is required";
    if (!expamt) errors.expamt = "Expense Amount required";

    setErrors(errors);

    let Edate = new Date().toISOString().split("T")[0];
    // console.log(Edate);
    // console.log(pgid);
    try {
      if (Object.keys(errors).length === 0) {
        const exp = {
          expName: expname,
          expAmt: expamt,
          expDate: Edate,
          pgname: pgid,
        };
        // setUser(user1);

        addExpense(exp);

        setExpname("");
        setExpamt("");
        navigate("/MyDashboard");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container">
      <div className="header">New Expense</div>
      <div className="label">
        Expense Name:
        <input
          type="text"
          className="inputbox"
          name="expname"
          list="expnames"
          value={expname}
          onChange={(e) => setExpname(e.target.value)}
        />
        <datalist id="expnames">
          {[...new Set(expenses.map((obj) => obj.expName))].map(
            (value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            )
          )}
        </datalist>
        {errors.expname ? (
          <div className="errortext">{errors.expname}</div>
        ) : null}
      </div>

      <div className="label">
        Expense Amount:
        <input
          type="text"
          className="inputbox"
          name="expamt"
          value={expamt}
          onChange={(e) => setExpamt(e.target.value)}
        />
        {errors.expamt ? (
          <div className="errortext">{errors.expamt}</div>
        ) : null}
      </div>
      <input
        type="submit"
        className="btn-cls"
        value="Submit"
        onClick={handleExpenseSubmit}
      />
    </div>
  );
};

export default AddExpense;
